export default __webpack_public_path__ + "static/media/ARM_Logo.49401664.png";